import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

import routes from './routes'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  try {
    if (to.matched.some(record => record.meta.noAuth)) {
      // next({ path: '/login', query: { redirect: to.path } })

      console.log('user run')
      if (store.state.hasData === false) {
        // if (store.state.username) {
        //   await store.dispatch('users/checkToken')
        // }
        await store.dispatch('color/getBgColorData')
        await store.dispatch('navbar/getMenuData')
        await store.dispatch('navbar/getSubMenuData')
        await store.dispatch('recruit/getHomeAdmissionsData')
        await store.dispatch('news/getHomeNewsData')
        await store.dispatch('contact/getContactData')
        await store.dispatch('services/getHomeTSData')
        await store.dispatch('media/getMediaData')
        await store.dispatch('footer/getFooterData')
        await store.dispatch('layout/getLayoutAdjData')
        console.log(store.state.username)
      }
      store.state.hasData = true
      if (to.path === '/login' && store.state.isLoggedIn) {
        next('/management-details')
      } else {
        next()
      }
    } else {
      if (store.state.hasData === false) {
        console.log('user_go')

        await store.dispatch('color/getBgColorData')
        await store.dispatch('navbar/getMenuData')
        await store.dispatch('navbar/getSubMenuData')
        await store.dispatch('contact/getContactData')
        await store.dispatch('layout/getLayoutAdjData')
        await store.dispatch('recruit/getHomeAdmissionsData')
        await store.dispatch('news/getHomeNewsData')
        await store.dispatch('services/getHomeTSData')
        await store.dispatch('media/getMediaData')
        await store.dispatch('footer/getFooterData')
      }
      store.state.hasData = true
      if (store.state.username) {
        await store.dispatch('users/checkToken')
      }
      if (store.state.isLoggedIn) {
        next()
      } else {
        next('/login')
      }
    }
  } catch (error) {
    // store.dispatch('setError', error.message || 'Something went wrong!')
    next(error) // Optional: Redirect to an error page or show error message
  } finally {
    // store.dispatch('setLoading', false)
  }
})
export default router
